"use client";

import { useTranslations } from "next-intl";
import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { SECTION_TITLE } from "@shared/constants/typography";

export function AnimeFaqSection() {
	const t = useTranslations("imageToAnime.faq");
	const [openItem, setOpenItem] = useState<number>(0);

	const faqItems = [
		"howItWorks",
		"imageTypes",
		"creditsCost",
		"downloadQuality",
		"privacySecurity",
		"multipleStyles",
		"deleteContent",
	];

	const toggleItem = (index: number) => {
		setOpenItem(openItem === index ? -1 : index);
	};

	return (
		<section className="py-16 bg-gray-50/50 dark:bg-gray-900/50">
			<div className="container mx-auto px-4">
				<div className="text-center mb-12">
					<h2 className={`${SECTION_TITLE.className} mb-4`}>
						{t("title")}
					</h2>
				</div>

				{/* DaisyUI-inspired Accordion */}
				<div className="max-w-3xl mx-auto space-y-3">
					{faqItems.map((item, index) => (
						<div
							key={item}
							className={`bg-white dark:bg-gray-800 border rounded-lg shadow-sm hover:shadow-md transition-all duration-200 ${
								openItem === index
									? "border-pink-200 dark:border-pink-700"
									: "border-gray-200 dark:border-gray-700"
							}`}
						>
							<button
								className={`w-full px-6 py-4 flex items-center justify-between text-left transition-colors rounded-t-lg focus:outline-none ${
									openItem === index
										? "bg-gray-50 dark:bg-gray-700/50"
										: "hover:bg-gray-50 dark:hover:bg-gray-700/30"
								}`}
								onClick={() => toggleItem(index)}
								aria-expanded={openItem === index}
								aria-controls={`faq-content-${index}`}
							>
								<span className="font-semibold text-base text-gray-900 dark:text-gray-100 pr-4">
									{t(`items.${item}.question`)}
								</span>
								<ChevronDown
									className={`h-5 w-5 text-gray-500 flex-shrink-0 transition-transform duration-200 ${
										openItem === index
											? "transform rotate-180"
											: ""
									}`}
								/>
							</button>

							<div
								id={`faq-content-${index}`}
								className={`overflow-hidden transition-all duration-300 ${
									openItem === index ? "max-h-96" : "max-h-0"
								}`}
							>
								<div className="px-6 pb-4 pt-2 text-base leading-relaxed text-gray-600 dark:text-gray-400 border-t border-gray-100 dark:border-gray-700">
									{t(`items.${item}.answer`)}
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
